import { useEffect, useState } from 'react';

const EMPTY = {
  nombreRedSocial: '',
};



export default function Modal({
  open,
  mode = 'new',
  data = null,
  onClose,
  onSubmit,
  inline = false,
}) {
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({
    nombreRedSocial: '',
  });

  const validateField = (field, rawValue) => {
    const value = typeof rawValue === 'string' ? rawValue.trim() : rawValue;
    let error = '';

    switch (field) {
      case 'nombreRedSocial':
        if (!value) error = 'Selecciona una red social.';
        break;
      default:
        break;
    }

    setErrors((prev) => ({ ...prev, [field]: error }));
    return !error;
  };

  const validateAll = () => {
    const fields = ['nombreRedSocial'];
    let isValid = true;
    fields.forEach(f => {
      if (!validateField(f, form[f])) isValid = false;
    });
    return isValid;
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    validateField(field, value);
  };

  useEffect(() => {
    if (mode === 'edit' && data) {
      const filled = {
        nombreRedSocial: data.nombreRedSocial ?? '',
      };
      setForm(filled);
      validateField('nombreRedSocial', filled.nombreRedSocial);
    } else {
      setForm(EMPTY);
      setErrors({ nombreRedSocial: '' });
    }
  }, [mode, data]);

  if (!open) return null;

  const hasErrors = Object.values(errors).some((e) => !!e);
  const isSaveDisabled = !form.nombreRedSocial?.trim() || hasErrors;

  const errorStyle = {
    color: '#b91c1c',
    fontSize: '.8rem',
    display: 'block',
    marginTop: '4px',
  };

  const Header = (
    <div
      className="roles-topbar"
      style={{
        marginBottom: '0.6rem',
        paddingRight: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: '0 0 auto',
      }}>
      <h3 className="roles-title" style={{ marginRight: 0 }}>
        {mode === 'new' ? 'Nueva red social' : 'Editar red social'}
      </h3>
      <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
    </div>
  );

  const Body = (
    <div
      style={{
        paddingLeft: '15%',
        paddingRight: 16,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.8rem',
        overflowY: 'auto',
        flex: '1 1 auto',
        minHeight: 0,
      }}>

      <div style={{ gridColumn: '1 / -1' }}>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Red Social (Que los usuarios registran en su perfil):</label>
        <br /><br />
        <input
          className={`infoField${errors.nombreRedSocial ? ' infoField--error' : ''}`}
          value={form.nombreRedSocial || ''}
          onChange={(e) => handleChange('nombreRedSocial', e.target.value)}
          placeholder="Escribe el nombre de la red social"
        />
        {errors.nombreRedSocial && <small style={errorStyle}>{errors.nombreRedSocial}</small>}
      </div>
    </div>
  );

  const Footer = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '.6rem',
        marginTop: '.8rem',
        paddingRight: 16,
        flex: '0 0 auto',
      }}
    >
      <button className="roles-btn" onClick={onClose}>Cancelar</button>
      <button
        className="btn-action"
        onClick={() => {
          if (validateAll()) onSubmit(form, mode);
        }}
        disabled={isSaveDisabled}
        style={{
          opacity: isSaveDisabled ? 0.5 : 1,
          cursor: isSaveDisabled ? 'not-allowed' : 'pointer',
        }}
      >
        {mode === 'new' ? 'Guardar' : 'Actualizar'}
      </button>
    </div>
  );

  if (inline) {
    return (
      <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        {Header}
        {Body}
        {Footer}
      </div>
    );
  }

  return (
    <div
      className="roles-confirm-overlay"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        zIndex: 1000,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <div
        className="roles-confirm-card"
        style={{
          width: 'min(720px, 96vw)',
          maxHeight: '85vh',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,.25)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {Header}
        {Body}
        {Footer}
      </div>
    </div>
  );
}
